export default "__VITE_ASSET__Bdv2Jvu___"